import { render, staticRenderFns } from "./NotificationPopup.vue?vue&type=template&id=3d905681&scoped=true"
import script from "./NotificationPopup.vue?vue&type=script&lang=js"
export * from "./NotificationPopup.vue?vue&type=script&lang=js"
import style0 from "./NotificationPopup.vue?vue&type=style&index=0&id=3d905681&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d905681",
  null
  
)

export default component.exports